import { FC, useState } from 'react';
import GalleryModal from '../../Modal/Gallery';
import NoImages from 'src/components/Items/NoImages';
import CustomSwiper from 'src/components/Items/CustomSwiper';
import useIsMobile from 'src/hooks/useIsMobile';

interface IProps {
  photos: {
    interior: string[];
    exterior: string[];
  };
}

const VanPhotos: FC<IProps> = ({ photos }) => {
  const isMobile = useIsMobile();
  const { interior, exterior } = photos;
  const [index, setIndex] = useState<number | null>(null);
  const [open, setOpen] = useState(false);

  const handleOpenGallery = (index: number) => {
    setIndex(index);
    setOpen(true);
  };

  return (
    <>
      <div className='van__imgs'>
        <div className='van__main-imgs'>
          {exterior.length || interior.length ? (
            <CustomSwiper data={isMobile ? [...exterior, ...interior] : exterior} />
          ) : (
            <NoImages />
          )}
        </div>
        <div className='van__info__imgs'>
          {interior.slice(0, 2).map((photo, index) => (
            <img
              key={index}
              src={photo}
              alt='inner'
              loading='lazy'
              onClick={() => handleOpenGallery(index)}
            />
          ))}
        </div>
      </div>
      <GalleryModal
        open={open}
        handleClose={() => setOpen(false)}
        imgs={[...photos.interior, ...photos.exterior]}
        index={index!}
      />
    </>
  );
};
export default VanPhotos;
